module.exports = __webpack_public_path__ + "media/components/src/assets/images/contact/img_send-92208951da096221f55bd1beb8fa44f4.svg";